module.exports = __webpack_public_path__ + "img/c-thermometer-img7-1.8c174986.jpg";